import { useState } from "react";
import { School, Loader2, GraduationCap } from "lucide-react";
import { becomeInstructor } from "@/lib/api";
import { toast } from "sonner";

// Onboarding: opt-in as an instructor. Free flip of role from `user` → `instructor`.
export const OptIn = ({ onDone }) => {
  const [saving, setSaving] = useState(false);
  const optIn = async () => {
    setSaving(true);
    try {
      await becomeInstructor();
      toast.success("Welcome, professor 🎓");
      onDone();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't switch role — try again");
    } finally {
      setSaving(false);
    }
  };
  return (
    <div className="max-w-2xl mx-auto rounded-3xl border border-border bg-card p-10 text-center">
      <span className="grid place-items-center h-14 w-14 rounded-2xl bg-accent/15 text-accent mx-auto">
        <School className="h-7 w-7" />
      </span>
      <h2 className="mt-5 font-serif text-3xl font-bold">Teach with Lectura</h2>
      <p className="mt-3 text-muted-foreground max-w-md mx-auto">
        Create a classroom, assign chapters (or share a specific lecture you built), track your students' progress and quiz scores, and export a gradebook — all in one place. Free to use, unlimited students.
      </p>
      <button
        data-testid="become-instructor-btn"
        onClick={optIn}
        disabled={saving}
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-accent text-accent-foreground px-8 py-3.5 font-semibold hover:opacity-90 transition disabled:opacity-60"
      >
        {saving ? <><Loader2 className="h-4 w-4 animate-spin" /> Setting up…</> : <><GraduationCap className="h-4 w-4" /> Become an instructor</>}
      </button>
    </div>
  );
};
